import { EpisodeState } from "./episodes-types";

export enum AssetType {
  Episode = "Episode",
  Image = "Image",
  Mask = "Mask",
}

export type RejectionReason = {
  id: string;
  reason: string;
};

export type MaskRejectionData = {
  id: string;
  state: string;
  url: string;
  rejectionReasons: RejectionReason[];
  rejectionNotes: string | null;
};

export type ImageRejectionData = {
  id: string;
  state: string;
  url: string;
  rejectionReasons: RejectionReason[];
  rejectionNotes: string | null;
  page: number;
  mask: MaskRejectionData | null;
};

export type EpisodeRejectionData = {
  id: string;
  story: string;
  category: string;
  subcategory: string;
  gender: string;
  rejectionNotes: string | null;
  state: EpisodeState;
  images: ImageRejectionData[];
  visualsAssignee: {
    id: string;
    username: string;
  } | null;
};

export type RejectionReasonsResponse = {
  result: EpisodeRejectionData[];
  nextCursor?: string;
};
